export default "__VITE_ASSET__Bqvg1Zuv__"